module.exports = __webpack_public_path__ + "static/media/Galano_Grotesque.f8ac88d0.otf";